import { Model } from "survey-react"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { useTranslation } from "react-i18next"
import { IPlainDataOptions } from "packages/survey-core/src/base-interfaces"
import { Collapse, CollapseProps } from "antd"

interface IProps {
  formDefinition: any
  formAnswers: any
  plainDataOptions?: IPlainDataOptions
}

function DiagnosticResult({
  formDefinition,
  formAnswers,
  plainDataOptions = {},
}: IProps) {
  const { t } = useTranslation()
  const survey = new Model(formDefinition)

  survey.data = formAnswers

  const items: CollapseProps["items"] = survey
    .getPlainData({
      includeQuestionTypes: true,
      includeValues: true,
      ...plainDataOptions,
    })
    .filter((question) => !String(question.name).endsWith("-Comment"))
    .map((question) => ({
      key: question.name,
      label: (
        <div className={styles.collapseHeader}>
          <div
            className={classNames(
              "body-heavy",
              styles.textContainer,
              styles.label
            )}
          >
            {question.title}
          </div>
          <div
            className={classNames(
              styles.textContainer,
              question.questionType === "checkbox" && styles.checkboxTypeText
            )}
          >
            {question.displayValue}
          </div>
        </div>
      ),
      collapsible: question.questionType === "checkbox" ? "header" : "disabled",
      showArrow: question.questionType === "checkbox",
      children:
        question.questionType === "checkbox"
          ? question.data?.map((choice) => (
              <div className={styles.collapseItem} key={choice.name}>
                <div
                  className={classNames(
                    "body-heavy",
                    styles.textContainer,
                    styles.choiceItemText
                  )}
                >
                  {t("choice")}
                </div>
                <div
                  className={classNames(
                    styles.textContainer,
                    styles.checkboxTypeText,
                    styles.choiceItemText
                  )}
                >
                  {choice.displayValue}
                </div>
              </div>
            ))
          : null,
    }))

  return (
    <div className={styles.diagnostic}>
      <Collapse items={items} />
    </div>
  )
}

export default DiagnosticResult
